<template>
  <div
    class="trezo-card p-[20px] md:p-[25px] text-center rounded-md"
    style="background: linear-gradient(153deg, #fad2d2 0%, #6fa3ec 100%)"
  >
    <div
      class="trezo-card-content py-px relative z-[1] mx-auto md:max-w-[245px]"
    >
      <h3
        class="text-lg dark:text-black md:text-[20px] leading-[1.2] mb-[15px] md:mb-[20px]"
      >
        <span class="font-normal">Have You Tried Our</span> New Mobile App?
      </h3>
      <img
        src="@/assets/images/nfts/nft-app.png"
        class="mx-auto"
        alt="nft-app-image"
      />
      <a
        href="#"
        target="_blank"
        class="mt-[15px] md:mt-[22px] inline-block rounded-md bg-primary-500 text-white transition-all text-[15px] md:text-md font-medium py-[6px] px-[16.5px] hover:bg-primary-400"
      >
        Download App
      </a>
      <div
        class="absolute top-1/2 -translate-y-1/2 left-0 right-0 w-[201px] h-[201px] rounded-full bg-white opacity-[.15] -z-[1] mx-auto"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NewMobileApp",
});
</script>
